module.exports = __webpack_public_path__ + "static/media/analytics.9368c145.png";